import React, { useState } from "react";
import CustomerAppointmentSearch from "./CustomerAppointmentSearch";

const CalendarSecondaryToolbar = ({
  customers,
  isMobile,
  recurringEnabled,
  onOpenRecurring,
  onOpenAppointment,
  onGoToDate,
}) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");

  const actionStyle = {
    minHeight: isMobile ? 46 : 50,
    minWidth: 0,
    padding: isMobile ? "8px 10px" : "10px 20px",
    border: "3px solid #E8761D",
    borderRadius: 12,
    background: "#000000",
    color: "#E8C98F",
    fontSize: isMobile ? 13 : 15,
    fontWeight: 900,
    cursor: "pointer",
    boxSizing: "border-box",
    whiteSpace: "nowrap",
  };

  const restoreActionStyle = (event) => {
    event.currentTarget.style.background = "#000000";
    event.currentTarget.style.color = "#E8C98F";
    event.currentTarget.style.borderColor = "#E8761D";
  };

  const applyActionHover = (event) => {
    event.currentTarget.style.background = "#FFC107";
    event.currentTarget.style.color = "#000000";
    event.currentTarget.style.borderColor = "#FFA500";
  };

  const closeDatePicker = () => {
    setSelectedDate("");
    setShowDatePicker(false);
  };

  const handleGoToDay = () => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(selectedDate);
    if (!match) return;
    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    if (
      date.getFullYear() !== Number(match[1])
      || date.getMonth() !== Number(match[2]) - 1
      || date.getDate() !== Number(match[3])
    ) return;
    onGoToDate(date);
    closeDatePicker();
  };

  return (
    <div style={{
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: isMobile ? "stretch" : "flex-end",
      gap: isMobile ? 8 : 12,
      width: "100%",
      marginBottom: 12,
      padding: isMobile ? 8 : 10,
      border: "3px solid #000000",
      borderRadius: 12,
      background: "#E8E2DA",
      boxSizing: "border-box",
    }}>
      {!isMobile && recurringEnabled ? (
        <button type="button" style={{ ...actionStyle, flex: "0 0 auto" }}
          onMouseEnter={applyActionHover}
          onMouseLeave={restoreActionStyle}
          onClick={onOpenRecurring}>
          + RECURRING
        </button>
      ) : null}

      <CustomerAppointmentSearch
        customers={customers}
        onOpenAppointment={onOpenAppointment}
        isMobile={isMobile}
      />

      {!isMobile ? (
        <button type="button" style={{ ...actionStyle, flex: "0 0 auto" }}
          onMouseEnter={applyActionHover}
          onMouseLeave={restoreActionStyle}
          onClick={() => setShowDatePicker(true)}>
          GO TO DATE
        </button>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: recurringEnabled ? "1fr 1fr" : "1fr", gap: 8 }}>
          {recurringEnabled ? (
            <button type="button" style={actionStyle}
              onMouseEnter={applyActionHover}
              onMouseLeave={restoreActionStyle}
              onClick={onOpenRecurring}>
              + RECURRING
            </button>
          ) : null}
          <button type="button" style={actionStyle}
            onMouseEnter={applyActionHover}
            onMouseLeave={restoreActionStyle}
            onClick={() => setShowDatePicker(true)}>
            GO TO DATE
          </button>
        </div>
      )}

      {showDatePicker ? (
        <div role="dialog" aria-modal="true" aria-label="Select date" style={{
          position: "fixed", inset: 0, zIndex: 10000, display: "flex",
          alignItems: "center", justifyContent: "center", padding: isMobile ? 12 : 20,
          background: "rgba(0,0,0,0.65)", boxSizing: "border-box",
        }}>
          <div style={{
            width: "100%", maxWidth: 360, padding: isMobile ? 16 : 20,
            border: "3px solid #E8761D", borderRadius: 14, background: "#365C91",
            color: "white", boxSizing: "border-box", boxShadow: "0 18px 0 rgba(0,0,0,0.25)",
          }}>
            <div style={{ fontWeight: 900, fontSize: 18, marginBottom: 14 }}>SELECT DATE</div>
            <input
              type="date"
              aria-label="Select date"
              value={selectedDate}
              onChange={(event) => setSelectedDate(event.target.value)}
              style={{ width: "100%", padding: 12, border: "3px solid #ffffff", borderRadius: 10, fontWeight: 900, boxSizing: "border-box" }}
            />
            <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
              <button type="button" style={{ ...actionStyle, flex: 1 }} disabled={!selectedDate} onClick={handleGoToDay}>
                GO TO DAY
              </button>
              <button type="button" style={{ ...actionStyle, flex: 1 }} onClick={closeDatePicker}>
                CANCEL
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CalendarSecondaryToolbar;
